import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import moment from 'moment';

export const options = {
  name: 'activityReports',
  baseType: 'ACTIVITY_REPORTS',
  apiEndpoint: 'activity_reports',
  transform: report => ({
    ...report,
    // replace actual attendances with reference to id, because we're going to
    // store attendances in a separate reducer
    attendanceIds: report.attendances.map(a => a.id)
  }),
  createNew: () => ({
    title: '',
    description: '',
    start_time: moment().startOf('minute').format(),
    end_time: moment().add(2, 'hours').startOf('minute').format(),
    activity_type_ids: []
  })
};

const selectors = createMetadataAPISelectors(options);
const operations = createMetadataAPIOperations(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
